import React, { useState } from "react";
import HomeButton from "../HomeButton/HomeButton";
import { Modal, Button } from "react-bootstrap";

function ProBlocker({ setIsBlocked, home }) {
  const [showModal, setShowModal] = useState(false);

  function getAppDownloadLink() {
    const platform = navigator.platform || "";
    let href = "";

    if (platform.startsWith("Mac")) {
      href =
        "https://apps.apple.com/eg/app/mechsit-sri-lanka-drivers-exam/id1599318476";
    } else if (platform.includes("Win")) {
      href =
        "https://play.google.com/store/apps/details?id=appinventor.aimechsita.sldl&hl=en";
    } else if (["iPhone", "iPad", "iPod"].includes(platform)) {
      href =
        "https://apps.apple.com/eg/app/mechsit-sri-lanka-drivers-exam/id1599318476";
    } else if (platform.includes("Linux") || platform.includes("Android")) {
      href =
        "https://play.google.com/store/apps/details?id=appinventor.aimechsita.sldl&hl=en";
    } else {
      console.log("Unknown or custom platform:", platform);
    }

    return href;
  }

  // const handleUpgradeClick = () => {
  //   // dispatch(upgradeToPro());
  //   // setIsBlocked(false);
  //   setShowModal(true); 
  // };

  const handleRedirect = () => {
    const link = getAppDownloadLink();
    if (link) {
      window.open(link, "_blank"); // open app store link in new tab
      setShowModal(false);
    }
  };

  return (
    <div className="pro-block-screen">
      <div className="pro-block-card">
        <h2 className="pro-title">Upgrade to Pro</h2>
        <p className="pro-subtitle">
          Unlock all premium papers & continue your journey without limits!
        </p>
        <div className="pro-actions">
          <HomeButton home={home} />
          <button onClick={handleRedirect} className="upgrade-btn">
            {/* Upgrade Now */}
            Get App For Now
          </button>
        </div>
      </div>

      {/* Modal */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Continue to Papers</Modal.Title>
        </Modal.Header>

        <Modal.Body className="text-center">
          {/* <p>
            We detected your device as:{" "}
            <span className="fw-bold text-primary">{navigator.platform}</span>
          </p> */}
          <p className="text-muted">
            Click below to download the app from the Continue this papers.
          </p>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleRedirect}>
            Go to Store
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default ProBlocker;
